"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStaticTool = createStaticTool;
exports.createDynamicTool = createDynamicTool;
const toolFactory_1 = require("./toolFactory");
function createStaticTool(config) {
    return {
        definition: (0, toolFactory_1.buildStaticTool)(config.definition),
        schema: config.definition.parameters,
        apply: config.apply,
    };
}
function createDynamicTool(config) {
    return {
        definition: (0, toolFactory_1.buildDynamicTool)(config.definition),
        schema: null,
        apply: config.apply,
    };
}
//# sourceMappingURL=toolProvider.js.map